<template>
	<div v-loading="loading">
		<div class="app-container">			 
			<!-- 企业许可信息 -->
			<div class="el-title">许可信息</div>
			<el-table v-loading="loading" border :data="xkxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50"/>
				<el-table-column label="许可证名称" align="center" prop="licname"/>
				<el-table-column label="许可证编号" align="center" prop="licno"/>
				<el-table-column label="发证日期" align="center" prop="licdate"/>
				<el-table-column label="有效期至" align="center" prop="licto"/>
				<el-table-column label="发证机关" align="center" prop="licauth"/>
				<el-table-column label="许可状态" align="center" prop="licto">
					<template slot-scope="scope">
						<el-tag :type="formatLicStatus(scope.row.licto)?'success':'danger'" effect="dark">
							{{formatLicStatus(scope.row.licto)?`有效`:`无效`}}
						</el-tag>
					</template>
				</el-table-column>
				 
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getQyXkxxList()" />
			 
		</div>
	</div>
</template>

<script>
	import {
		 listQyXkxx
	} from "@/api/qygzs/yqyd";

	export default {
		name: 'QyXkxx',
		props: {
			//企业内部序号
			pripid: {
				type: String,
				require: true
			}
		},
		watch: {
			pripid(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {				 
				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,				 
				//【总条数
				total: 0,
				// 表格数据
				xkxxList: [],				 
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},	 

			}
		},
		created() {
			this.init(); 
		},
		 
		methods: {
			init() {
				this.loading = true;				 			 
				this.getQyXkxxList();
				 
			},
			 
			// 获取出资信息
			getQyXkxxList() {
				this.loading = true;
				this.queryParams.pripid = this.pripid;
				listQyXkxx(this.queryParams).then(response => {
					this.xkxxList = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			formatLicStatus(val){
				if(this.isEmptyStr(val)){
					return true;
				}
				let curDate=this.parseTime(new Date(), '{y}-{m}-{d}')
				return this.dateCompare(val,curDate); 
			},
			 
		 

		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
